import React, { useState, useEffect } from 'react';
import { IonGrid, IonRow, IonLabel, IonCol, IonIcon } from '@ionic/react';
import "./SelectComponent.scss";

export interface IOption {
  name: string;
  code: string;
  value?: string;
}

const SelectComponent: React.FC<any> = (props: any) => {
  const { options, name, placeholder, label, value } = props;
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState<IOption>({} as IOption);
    
  useEffect(() => {
    const item = options.find((option: any) => (option.code === value || option.key === value));
    if(item) {
      setSelectedOption(item);
    } else {
      setSelectedOption({} as IOption);
    }
  }, [value])
  const handleSelectChange = (option: IOption) => {
    setSelectedOption(option);
    setShowOptions(false);
    props.handleChange({name, value: option});
  }
  return (
    <IonGrid class="select-grid">
      <IonRow class="select-label-row">
        <IonLabel class="select-label">{label}</IonLabel>
      </IonRow>
      <IonRow
        data-test="show-options"
        class="select-type"
        onClick={() => setShowOptions(!showOptions)}
      >
        <IonCol class="select-name">
          {selectedOption?.name ? selectedOption.name : selectedOption.value ? selectedOption.value : placeholder}
        </IonCol>
        <IonCol class="dropDown-icon">
          <IonIcon src="/assets/icon/grid-down-arrow.svg" />
        </IonCol>
      </IonRow>
      {options && showOptions ? (
        <IonGrid className="select-suggetion-grid">
          {options.map((option: IOption, index: number) => (
            <IonRow
              data-test="select-change"
              className="select-change"
              key={index}
              onClick={() => {
                handleSelectChange(option);
              }}
            >
              <IonCol className="select-suggestion-item">
                {option.name || option.value}
              </IonCol>
            </IonRow>
          ))}
        </IonGrid>
      ) : null}
    </IonGrid>
  )
};

export default SelectComponent;
